import Service from '@/helpers/service'

export default {

    index(params) {
        return Service().get('monitoring-machine/index', {params});
    },
    getCustomer(params) {
        return Service().get('monitoring-machine/get-customer', {params});
    },
    show(id) {
        return Service().get('monitoring-machine/show/'+id);
    },
    create(params) {
        return Service().post('monitoring-machine/create', params, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
        });
    },
    update(id, params) {
        return Service().post('monitoring-machine/update/'+id, params, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
        });
    },
    delete(id) {
        return Service().post('monitoring-machine/delete/'+id);
    },
}